import { MinusBoxOutlineIcon } from './MinusBoxOutlineIcon';

/**
 * author: Google
 * id D37AECEA-5BC3-4C57-8886-BC6C1A86987D
 * name minus-box-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-box-outline.svg
 * tags
 * - Math 
 * - Form 
 */
export const CheckboxIndeterminateOutlineIcon = MinusBoxOutlineIcon;
export default CheckboxIndeterminateOutlineIcon